import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var LockFilled = function LockFilled(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1a3.667 3.667 0 00-3.667 3.667V6.25H4a1.5 1.5 0 00-1.5 1.5v5.75A1.5 1.5 0 004 15h8a1.5 1.5 0 001.5-1.5V7.75a1.5 1.5 0 00-1.5-1.5h-.333V4.667A3.667 3.667 0 008 1zm1.833 5.25h1.834-1.834zm-3.666 0H4.333h1.834zm0 0h3.666V4.583a1.833 1.833 0 00-3.666 0V6.25zm.458 4.375c0-.725.616-1.313 1.375-1.313.76 0 1.375.588 1.375 1.313S8.759 11.938 8 11.938c-.76 0-1.375-.588-1.375-1.313z",
    fill: "currentColor"
  }));
};
export default LockFilled;